import defaultIncomeFlow from './flowDefinition';

export default defaultIncomeFlow;
